module.exports = __webpack_public_path__ + "img/10.d233906b.webp";